import React from "react";
import { Modal, Box, Typography } from "@mui/material";

const ConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  loading,
  title,
  message,
}) => {
  return (
    <Modal
      open={isOpen}
      onClose={onCancel}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 500,
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 2,
          borderRadius: 2,
        }}
      >
        <Typography
          id="confirmation-modal-title"
          variant="h6"
          component="h2"
          mb={2}
        >
          {title}
        </Typography>
        <Typography id="confirmation-modal-description" mb={4}>
          {message}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <button
            style={{
              border: "1px solid #3c4b67",
              padding: "5px 30px ",
              textAlign: "center",
            }}
            type="button"
            className="btn btn-md"
            onClick={onCancel}
          >
            No
          </button>

          <button
            style={{
              border: "none",
              padding: "10px 30px ",
              textAlign: "center",
            }}
            type="button"
            className="btn btn-primary btn-md"
            onClick={onConfirm}
            disabled={loading}
          >
            Yes
          </button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
